<template>
  <div class="container">
    <div class="row minor-height">
      <div class="col-md-4">
        <div
          class="jumbotron"
          @click="location(banner.first.url)"
          :style="
            'cursor: pointer; background-image: url(' +
              imgPreUrl +
              banner.first.photo +
              'x640.jpg);'
          "
        ></div>
      </div>
      <div class="col-md-4">
        <div
          class="jumbotron"
          @click="location(banner.second.url)"
          :style="
            'cursor: pointer; background-image: url(' +
              imgPreUrl +
              banner.second.photo +
              'x640.jpg);'
          "
        ></div>
      </div>
      <div class="col-md-4">
        <div
          class="jumbotron"
          @click="location(banner.third.url)"
          :style="
            'cursor: pointer; background-image: url(' +
              imgPreUrl +
              banner.third.photo +
              'x640.jpg);'
          "
        ></div>
      </div>
    </div>
    <br />
    <br />
    <h2><strong>Tenemos estos productos para tí</strong></h2>
    <br />
    <!-- Ofertas y promociones escritorio y movil -->
    <div class="best-products d-none d-sm-block" v-if="offerProducts.length != 0">
      <h6 class="subtitle-home" style="text-align: left;">
        <strong>Ofertas y Promociones </strong> <router-link to="/productos"> Ver todo</router-link>
      </h6>
      <br />
      <agile
        ref="carousel"
        :arrows="false"
        :speed="650"
        :timing="'linear'"
        :fade="true"
        :autoplay="true"
        :pauseOnHover="false"
        :autoplaySpeed="9000"
      >
        <template v-for="num in carouselOffers">
          <div :class="'slide slide--x slide-products'" v-bind:key="num">
            <div class="row">
              <div
                class="col-sm-6 col-md-3 col-lg-2dot4"
                v-for="(product_item, index) in offerProducts.slice(num * 5 - 5, num * 5)"
                :key="index"
              >
                <CardTemplateDiscount :item="product_item.productos" />
              </div>
              <div class="col-sm-12"><br /><br /></div>
            </div>
            <div class="row"></div>
          </div>
        </template>
      </agile>
    </div>
    <div class="best-products d-block d-sm-none" v-if="offerProducts.length != 0">
      <h6 class="subtitle-home" style="text-align: left;">
        <strong>Ofertas y Promociones </strong> <router-link to="/productos"> Ver todo</router-link>
      </h6>
      <br />
      <agile
        ref="carousel"
        :arrows="false"
        :speed="650"
        :timing="'linear'"
        :fade="true"
        :autoplay="true"
        :pauseOnHover="false"
        :autoplaySpeed="9000"
      >
        <template v-for="(product_item, index) in offerProducts">
          <div :class="'slide slide--x slide-products'" v-bind:key="index">
            <div class="row">
              <div class="col-sm-6 col-md-3 col-lg-2dot4">
                <CardTemplateDiscount :item="product_item.productos" />
              </div>
              <div class="col-sm-12"><br /><br /></div>
            </div>
          </div>
        </template>
      </agile>
    </div>
    <!-- Productos con descuento escritorio y movil -->
    <div class="best-products d-none d-sm-block" v-if="discountsProducts.length != 0">
      <h6 class="subtitle-home" style="text-align: left;">
        <strong>Productos con Descuento </strong>
      </h6>
      <br />
      <agile
        ref="carousel"
        :arrows="false"
        :speed="650"
        :timing="'linear'"
        :fade="true"
        :autoplay="true"
        :pauseOnHover="false"
        :autoplaySpeed="9000"
      >
        <template v-for="num in discountsCarousel">
          <div :class="'slide slide--x slide-products'" v-bind:key="num">
            <div class="row">
              <div
                class="col-sm-6 col-md-3 col-lg-2dot4"
                v-for="(product_item, index) in discountsProducts.slice(num * 5 - 5, num * 5)"
                :key="index"
              >
                <CardTemplateDiscount :item="product_item" />
              </div>
              <div class="col-sm-12"><br /><br /></div>
            </div>
            <div class="row"></div>
          </div>
        </template>
      </agile>
    </div>
    <div class="best-products d-block d-sm-none" v-if="discountsProducts.length != 0">
      <h6 class="subtitle-home" style="text-align: left;">
        <strong>Productos con Descuento </strong>
      </h6>
      <br />
      <agile
        ref="carousel"
        :arrows="false"
        :speed="650"
        :timing="'linear'"
        :fade="true"
        :autoplay="true"
        :pauseOnHover="false"
        :autoplaySpeed="9000"
      >
        <template v-for="(product_item, index) in discountsProducts">
          <div :class="'slide slide--x slide-products'" v-bind:key="index">
            <div class="row">
              <div class="col-sm-6 col-md-3 col-lg-2dot4">
                <CardTemplateDiscount :item="product_item" />
              </div>
              <div class="col-sm-12"><br /><br /></div>
            </div>
          </div>
        </template>
      </agile>
    </div>
    <!-- Productos Sugeridos escritorio y movil -->
    <div class="best-products d-none d-sm-block" v-if="bestProducts.length != 0">
      <h6 class="subtitle-home" style="text-align: left;">
        <strong>Productos Sugeridos </strong> <router-link to="/productos"> Ver todo</router-link>
      </h6>
      <br />
      <agile
        ref="carousel"
        :arrows="false"
        :speed="650"
        :timing="'linear'"
        :fade="true"
        :autoplay="true"
        :pauseOnHover="false"
        :autoplaySpeed="9000"
      >
        <template v-for="num in bestCarousel">
          <div :class="'slide slide--x slide-products'" v-bind:key="num">
            <div class="row">
              <div
                class="col-sm-6 col-md-3 col-lg-2dot4"
                v-for="(product_item, index) in bestProducts.slice(num * 5 - 5, num * 5)"
                :key="index"
              >
                <CardTemplateDiscount :item="product_item" />
              </div>
              <div class="col-sm-12"><br /><br /></div>
            </div>
            <div class="row"></div>
          </div>
        </template>
      </agile>
    </div>
    <div class="best-products d-block d-sm-none" v-if="bestProducts.length != 0">
      <h6 class="subtitle-home" style="text-align: left;">
        <strong>Productos Sugeridos </strong> <router-link to="/productos"> Ver todo</router-link>
      </h6>
      <br />
      <agile
        ref="carousel"
        :arrows="false"
        :speed="650"
        :timing="'linear'"
        :fade="true"
        :autoplay="true"
        :pauseOnHover="false"
        :autoplaySpeed="9000"
      >
        <template v-for="(product_item, index) in bestProducts">
          <div :class="'slide slide--x slide-products'" v-bind:key="index">
            <div class="row">
              <div class="col-sm-6 col-md-3 col-lg-2dot4">
                <CardTemplateDiscount :item="product_item" />
              </div>
              <div class="col-sm-12"><br /><br /></div>
            </div>
          </div>
        </template>
      </agile>
    </div>
  </div>
</template>
<style lang="scss">
.h1-slider {
  text-transform: uppercase;
}
.dropdown .dropdown-menu {
  border-radius: 0;
}
.agile {
  position: relative;
  &__track {
  }
  &__arrow {
    height: 100%;
    top: 0;
    width: 80px;
    background-color: transparent;
    border: none;
    bottom: -11px;
    margin: 0;
    padding: 0;
    position: absolute;
    transition-duration: 0.3s;
    &:hover {
      background-color: rgba(#000, 0.5);
      #arrow-svg {
        fill: #fff;
      }
    }

    &[disabled] {
      display: none;
    }

    #arrow-svg {
      fill: rgba(#fff, 0.4);
      height: 25px;
    }

    &--prev {
      left: 0;
    }

    &--next {
      right: 0;
    }

    svg {
      fill: #888;
      height: 24px;
      transition-duration: 0.3s;
    }
  }

  &__dots {
    bottom: 5%;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
  }

  &__dot {
    button {
      opacity: 0.4;
      background-color: grey;
      border: 1px solid grey;
      border-radius: 50%;
      cursor: pointer;
      display: block;
      height: 14px;
      margin: 10px;
      &:hover {
        background-color: grey;
      }
    }
    &--current {
      button {
        background-color: #fff;
      }
    }
  }

  .slide {
    background: {
      position: center;
      size: cover;
    }
    height: auto !important;
    &:before {
      background-color: rgba(#000, 0.2);
      content: '';
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }
  }

  .slide-products {
    background: {
      position: center;
      size: cover;
    }
    height: auto !important;
    &:before {
      background-color: var(--primary-color);
      content: '';
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }
  }
}
</style>

<script>
import { errorToaster } from '@/components/shared/service/ErrorHandler';
import CardLoader from '@/components/products/catalog/CardLoader';
import CardTemplateDiscount from '@/components/products/catalog/CardTemplateDiscount';
import { config_settings } from '@/config.js';
import {
  getProductsToHome,
  getOfferProductsToHome,
  getSubProductswDiscount,
} from '@/service/catalog.service.js';

export default {
  name: 'BestProductsModule',
  components: { CardLoader, CardTemplateDiscount },
  props: ['banner'],
  data() {
    return {
      bestProducts: [],
      offerProducts: [],
      loading: false,
      imgPreUrl: config_settings.PHOTO_SERVER_URL + '/',
      carouselOffers: 1,
      bestCarousel: 2,
      discountsProducts: [],
      discountsCarousel: 1,
    };
  },
  methods: {
    getBestProducts() {
      this.loading = true;
      getProductsToHome()
        .then((response) => {
          this.loading = false;
          this.bestProducts = response.data.products;
        })
        .catch((error) => {
          errorToaster('The server encountered an unexpected condition.', 'Internal Error 500');
        });
      this.loading = false;
    },

    getOfferProducts() {
      this.loading = true;
      getOfferProductsToHome()
        .then((response) => {
          this.loading = false;
          this.offerProducts = response.data.offer;
          if (this.bestProducts.length > 5) {
            this.carouselOffers = 2;
          } else {
            this.carouselOffers = 1;
          }
        })
        .catch((error) => {
          this.carouselOffers = 1;
        });
      this.loading = false;
    },

    getDiscountProducts() {
      this.loading = true;
      getSubProductswDiscount()
        .then((response) => {
          this.loading = false;
          this.discountsProducts = response.data.discounts_products;
          if (this.discountsProducts.length > 5) {
            this.discountsCarousel = 2;
          } else {
            this.discountsCarousel = 1;
          }
          this.discountsProducts = this.discountsProducts.slice(0, 10);
        })
        .catch((error) => {
          this.discountsCarousel = 1;
        });
      this.loading = false;
    },

    location(url) {
      window.location = url;
    },
  },
  created() {
    this.getBestProducts();
    this.getOfferProducts();
    //this.getDiscountProducts();
  },
};
</script>

<style>
.best-products {
  margin-bottom: 10px;
}
.jumbotron {
  background-size: 100% 100%;
}
</style>
